import { responsiveFontSizes, createTheme } from '@mui/material';
import { COLORS } from './utils/colors';

let theme = createTheme({});
theme = createTheme({
  components: {
    MuiGrid: {
      styleOverrides: {
        root: {
          /*
          marginTop: '-1rem',
          width: 'calc(100% + 1rem)',
          marginLeft: '-1rem',
          */
          '& > .MuiGrid-item': {
            paddingLeft: '1rem',
            //paddingTop: '1rem',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: '-.25rem',
          maxWidth: 'calc(100% - 1.5rem)',
          //transform: 'translate(.875rem, 1rem) scale(1)',
          '&.Mui-focused': {
            color: COLORS.PRIMARY,
          },
          '&$focused': {
            color: 'currentColor',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          letterSpacing: '0.5px',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        maxWidthLg: {
          [theme.breakpoints.up('lg')]: {
            maxWidth: '1440px',
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundSize: 'cover',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '2rem',
          textTransform: 'none',
          '&:active': {
            //backgroundColor: COLORS.PRIMARY,
          },
          '&:hover': {
            //backgroundColor: COLORS.PRIMARY,
            //color: COLORS.WHITE,
          },
        },
      },
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            borderColor: COLORS.PRIMARY,
            color: COLORS.PRIMARY,
            '&:hover': {
              borderColor: COLORS.PRIMARY,
              backgroundColor: COLORS.PRIMARY,
              color: COLORS.WHITE,
            },
          },
        },
        {
          props: { variant: 'contained' },
          style: {
            backgroundColor: COLORS.PRIMARY,
            color: COLORS.WHITE,
            '&:hover': {
              backgroundColor: COLORS.PRIMARY,
              opacity: 0.8,
            },
            '&:active': {
              backgroundColor: COLORS.PRIMARY,
            },
          },
        },
      ],
    },
    MuiIconButton: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '.5rem',
          '&:hover $notchedOutline': {
            borderColor: 'currentColor',
          },
          '&$focused $notchedOutline': {
            borderColor: 'currentColor',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: COLORS.PRIMARY,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: COLORS.PRIMARY,
          },
          '&:-internal-autofill-selected': {
            backgroundColor: 'transparent',
          },
        },
        input: {
          padding: '.75rem', // 1.5rem',
          color: 'black',
          '&:-internal-autofill-selected': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          top: '-.25rem',
          '&.Mui-focused': {
            color: COLORS.PRIMARY,
          },
          '&:-internal-autofill-selected': {
            backgroundColor: 'transparent',
          },
        },
        input: {
          '&:-internal-autofill-selected': {
            backgroundColor: 'transparent',
          },
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          '&:-internal-autofill-selected': {
            backgroundColor: 'transparent',
          },
          '&.MuiInputBase-input::before': {
            content: '""',
            backgroundColor: 'transparent !important',
          },
          'input:-internal-autofill-selected': {
            backgroundColor: 'transparent',
          },
        },
        input: {
          //padding: '.75rem 1.5rem !important',
          '&:-internal-autofill-selected': {
            backgroundColor: 'transparent',
          },
          '&:-internal-autofill-selected::before': {
            backgroundColor: 'transparent',
          },
          '&:-internal-autofill-selected::after': {
            backgroundColor: 'transparent',
          },
          '&.MuiInputBase-input::before': {
            content: '""',
            backgroundColor: 'transparent !important',
          },
        },
      },
    },
  },
  typography: {
    fontFamily: ['Montserrat', 'sans-serif'].join(','),
    fontSize: 13,
    h1: {
      fontSize: 40,
    },
    h2: {
      fontSize: 32,
    },
    h3: {
      fontSize: '1.5rem',
    },
    h4: {
      fontSize: '1.25rem',
    },
    h5: {
      fontSize: '1rem',
    },
    h6: {
      fontSize: '.875rem',
    },
  },
  palette: {
    primary: {
      ...theme.palette.primary,
      main: '#FF6E00',
    },
  },
});

export default responsiveFontSizes(theme);
